import styled from 'styled-components'
import AlarmIcon from '../../icons/AlarmIcon'
import JobTypeIcon from '../../icons/JobTypeIcon'
import PaymentsIcon from '../../icons/PaymentsIcon'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const RoleName = styled.div`
  font-size: 20px;
  font-weight: bold;
`
export const ShowDiv = styled.div`
  /* font-size: 15px;
 color: blue;
 text-align: left; */
 color: rgb(50, 73, 215);
font-weight: bold;
cursor: pointer;
`
export const Atag = styled.a`
color:#3249D7;
`
export const RoleDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`
export const DegreeDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_BASE)};
  line-height: 30px;
  color: #ababab;
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  margin-right: ${props => (props.marginRight ? props.marginRight : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '')};
`
export const SubtitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
  margin-top: ${props => (props.margintop ? props.margintop : '0px')};
`
export const TypeDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
`
export const ExperienceDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  height: 40px;
`
export const SalaryDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  height: 40px;
`

export const TextDiv = styled.span`
  font-size: 16px;
  padding-top: -8px;
`

export const AlarmIconDiv = styled(AlarmIcon)`
  font-size: 24px;
  margin-right: 8px;
`
export const IconDiv = styled.div`
  display: flex;
  border-radius: 10px;
  background-color: #e2f5fd;
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
  width: 30px;
  height: 30px;
`
export const JobTypeDiv = styled(JobTypeIcon)`
  font-size: 24px;
  margin-right: 8px;
`
export const PaymentDiv = styled(PaymentsIcon)`
  font-size: 24px;
  margin-right: 8px;
`
export const CompanyDiv = styled.div`
  background-color: transparent;
`
export const CompanyIcon = styled.div`
  display: flex;
  background-color: #f8f8f8;
  width: 50px;
  height: 50px;
  align-content: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
`
export const CompanyDivision = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
`
export const CompanyType = styled.div``
export const ImageContainer = styled.div``
export const CompanyName = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-family: 700;
  font-size: 1px;
  line-height: 24px;
  color: #343e59;
`
export const CorporateName = styled.div``
export const Division = styled.div`
  display: flex;
  flex-direction: column;
`
export const RowDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: -30px;
`
export const CityDiv = styled.div`
  margin-left: -25px;
`
export const WebSiteDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.gap ? props.gap : '0')};
`
export const TagDiv = styled.div`
  display: flex;
  flex-direction: row;
`
export const SkillDiv = styled.div``
export const DateDiv = styled.div`
  border: 2px solid #c5e4fa;
  padding: 10px;
  background-color: #f3fbfe;
  border-radius: 10px;
  height: 70px;
  align-content: center;
`
export const LabelDiv = styled.div``
export const DateView = styled.div``
export const DateDivision = styled.div`
  display: flex;
  flex-direction: column;
`

export const TitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_700)};
  font-size: ${FONT.F_2XL};
  line-height: 30px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 0;
`

export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  white-space: ${props => (props.nowrap ? 'nowrap' : 'normal')};
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  padding: ${props => (props.padding ? props.padding : '')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  width: ${props => (props.width ? props.width : '')};

  @media (max-width: 1100px) {
    width: auto;
  }
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
  ${props => props.afterContent && `::after { content: ',';}`}

  :last-child:after {
    content: '';
  }
`
export const SubtitleLarge = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
  margin-bottom: 5px;
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
`

export const SkillList = styled.ul`
  padding-inline-start: 20px;
`
export const AndDivision = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: 1000px;
  color: #010E30;
`
export const CompensationText = styled.span`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 22px;
  letter-spacing: 0.2px;
  color: ${COLORS.GREY_T_10}; /* darkest */
  display: inline-flex;
  align-items: center;
`

export const CompensationBreakup = styled.span`
  font-size: ${FONT.F_SM};
  margin-left: 10px;
  white-space: nowrap;

  /* label text */
  color: ${COLORS.GREY_T_20};
  font-weight: ${FONT.FW_500};

  /* numbers inside breakup */
  span {
    color: ${COLORS.GREY_T_10};
    font-weight: ${FONT.FW_600};
  }
`

export const CompensationType = styled.span`
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_20};
  margin-left: 8px;
  white-space: nowrap;
`